import User from './user.model'

let storeContent = utils.generateStore({
   User,
   users: [],
   selectedUsers: [],
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async addUser(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               await api.fetchEndpointSecure({
                  resource: 'auth',
                  action: 'user:create',
                  data: {
                     names: data.name,
                     phone_number: data.phone,
                     email: data.email,
                     role: data.role,
                  },
                  meta_data: {}
               })

               await ctx.dispatch('fetchUsers')
               ctx.commit('show_create_modal', false)
               $notify('success', 'User Created', `User ${data.name} successfully created.`,5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async editUser(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               await api.fetchEndpointSecure({
                  resource: 'auth',
                  action: 'user:update',
                  data: {
                     id: ctx.getters.selectedUsers[0]._id,
                     record: {
                        names: data.names,
                        phone_number: data.phone_number,
                        role: data.role,
                     }
                  },
                  meta_data: {}
               })

               await ctx.dispatch('fetchUsers')
               ctx.commit('show_edit_modal', false)
               $notify('success', 'User Created', `User ${data.name} successfully created.`,5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deleteUser(ctx) {
         try {
            ctx.commit('loading', true)

            for (const user of ctx.getters.selectedUsers) {
               let res = await api.fetchEndpoint({
                  resource: 'auth',
                  action: 'user:delete',
                  data: {
                     id: user._id,
                  },
                  meta_data: {}
               })
            }
            
            ctx.commit('show_delete_modal', false)
            await ctx.dispatch('fetchUsers')
            $notify('success', 'User(s) Deleted', `${ctx.getters.selectedUsers.length} users successfully deleted.`,5)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      handleActions(ctx,payload){
         console.log(payload)
         if(payload.action === 'user:edit'){
            let User = ctx.getters.User
            User.forms.editUser.data = payload.rows[0]

            ctx.commit('User',User)
            ctx.commit('show_edit_modal',true)
            ctx.commit('selectedUsers',payload.rows)
         }else if(payload.action === 'user:delete'){
            ctx.commit('delete_message',` ${payload.rows.length} user(s)`)
            ctx.commit('show_delete_modal',true)
            ctx.commit('selectedUsers',payload.rows)
         }
      },
      async fetchData(ctx){
         try {
            ctx.commit('show', false)
            await ctx.dispatch('fetchFormData')
            await ctx.dispatch('fetchUsers')
            Event.$emit('loader:show',false)
         } catch (err) {
            throw err
         }
      },
      async fetchUsers(ctx){
         try {
            ctx.commit('show', false)
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {},
               meta_data: {
                  service: "user",
                  collection: "user",
               }
            })
            ctx.commit('users',res.result.records)
         } catch (err) {
            throw err
         }
      },
      async fetchFormData(ctx) {
         try {
            // Fetch User Roles
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {},
               meta_data: {
                  service: "user",
                  collection: "role",
               }
            })

            let Model = utils.appendSelectData({
               Model: ctx.getters.User,
               forms: ['addUser','editUser'],
               model: 'role',
               label: 'name',
               dataField: 'code',
               data: res.result.records
            })
            ctx.commit('User', Model)
         } catch (err) {
            throw err
         }
      }
   }
};